import React, { forwardRef } from 'react';

import { styled, Typography } from '@mui/material';

export const Content = styled(
  forwardRef((props, ref) => (
    <Typography
      ref={ref} variant='pn5' color='primary.gray6' {...props}
    />
  ))
)({
  flex : 1,
  p    : {
    marginBlockStart : '0px',
    marginBlockEnd   : '20px',
  },
  ul : {
    paddingInlineStart : '15px',
  },
});
